import { render, staticRenderFns } from "./signinResult.vue?vue&type=template&id=2ef238ac&"
import script from "./signinResult.vue?vue&type=script&lang=js&"
export * from "./signinResult.vue?vue&type=script&lang=js&"
import style0 from "./signinResult.vue?vue&type=style&index=0&id=2ef238ac&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports